import { render } from "./ClientSays.vue?vue&type=template&id=2639fd12"
import script from "./ClientSays.vue?vue&type=script&lang=js"
export * from "./ClientSays.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__